module.exports = __webpack_public_path__ + "img/terminal-hse-guideline-qr.d1767ca4.png";